import React from 'react';
import './TrooprAuth.css';

// Shared chrome for the auth screens: brand nav + centered card.
// Always light — the user's theme (incl. OS dark) applies only inside the app.
// The brand mark below is a copy of troopr-ui's TrooprLogo (Logos.jsx) — a
// user can land on either app's auth, so keep the two in lockstep.
const AuthShell = ({ children }) => {
  return (
    <div className="tpr-auth">
      <div className="tpr-auth__nav">
        <span className="tpr-auth__brand">
          <svg
            className="tpr-auth__logo"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
          >
            <rect width="32" height="32" rx="16" fill="#5039BB" />
            <g fill="#fff">
              <circle cx="11" cy="11" r="2.1" />
              <circle cx="16" cy="11" r="2.1" />
              <circle cx="21" cy="11" r="2.1" opacity="0.55" />
              <circle cx="16" cy="16" r="2.1" />
              <circle cx="16" cy="21" r="2.1" />
            </g>
          </svg>
          <span className="tpr-auth__wordmark">Troopr</span>
        </span>
        <a
          className="tpr-auth__nav-link"
          href="https://www.troopr.ai/demo"
          target="_blank"
          rel="noopener noreferrer"
        >
          Book a demo
        </a>
      </div>
      <div className="tpr-auth__card">{children}</div>
    </div>
  );
};

export default AuthShell;
